class ObjectBuilder {
  constructor(fields = [], objects = {}, args = {}, fragmentApplications = [], inlineFragments = {}, objectName) {
    this.fields = fields;
    this.objects = objects;
    this.args = args;
    this.fragmentApplications = fragmentApplications;
    this.inlineFragments = inlineFragments;
    this.objectName = objectName;
  }
  argument(name, value) {
    return new ObjectBuilder(
      this.fields,
      this.objects,
      { ...this.args, [name]: value },
      this.fragmentApplications,
      this.inlineFragments,
      this.objectName
    );
  }
  name(name) {
    return new ObjectBuilder(
      this.fields,
      this.objects,
      this.args,
      this.fragmentApplications,
      this.inlineFragments,
      name
    );
  }
  field(name) {
    return new ObjectBuilder(
      [...this.fields, name],
      this.objects,
      this.args,
      this.fragmentApplications,
      this.inlineFragments,
      this.objectName
    );
  }
  object(name, builder) {
    if (!(builder instanceof ObjectBuilder)) {
      builder = builder(new ObjectBuilder());
    }
    return new ObjectBuilder(
      this.fields,
      { ...this.objects, [name]: builder },
      this.args,
      this.fragmentApplications,
      this.inlineFragments,
      this.objectName
    );
  }
  inlineFragment(typeName, builder) {
    if (!(builder instanceof ObjectBuilder)) {
      builder = builder(new ObjectBuilder());
    }
    return new ObjectBuilder(
      this.fields,
      this.objects,
      this.args,
      this.fragmentApplications,
      { ...this.inlineFragments, [typeName]: builder },
      this.objectName
    );
  }
  applyFragment(fragmentName) {
    return new ObjectBuilder(
      this.fields,
      this.objects,
      this.args,
      [...this.fragmentApplications, fragmentName],
      this.inlineFragments,
      this.objectName
    );
  }
}
export {
  ObjectBuilder
};
//# sourceMappingURL=ObjectBuilder.js.map
